// cp-app image build only (webpack.web.config.js aliases "date-fns/locale" here
// when CP_APP_IMAGE_BUILD=1). The barrel re-exports all 531 locales; the app
// imports only `hi` (src/screens/LGL/index.js, src/components/LGL/
// PreviousMonthStats.js). A locale imported from "date-fns/locale" that isn't
// re-exported here is undefined on web, so add it here too.
exports.hi = require("date-fns/locale/hi").hi;
